module.exports = __webpack_public_path__ + "static/media/chairs.d985285f.png";